import React from 'react';
import styled from 'styled-components';
import recommendedShowsBlockShape from 'shapes/components/recommendedShowsBlockShape';
import ImageList from '@mui/material/ImageList';
import PropTypes from 'prop-types';
import { prop } from 'styled-tools';

const ImageListWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  overflow: hidden;
`;

export const StyledImageList = styled(ImageList)`
  width: 100vw;
  flex-wrap: nowrap;
  overflowX: 'auto';
  // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
  transform: translateZ(0);

  padding-left: 1rem;
  padding-right: 1rem;
  width: 100%;

  // Overriding inline styles from material-ui; had to use !important
  .MuiImageListItem-root {
    height: 100% !important;
    width: ${prop('$tileWidth')} !important;
  }
`;

ImageListSlider.propTypes = {
  children: recommendedShowsBlockShape.isRequired,
  spacing: PropTypes.number,
  tileWidth: PropTypes.string
};

function ImageListSlider({ children, spacing = 13, tileWidth = '44%' }) {
  return (
    <ImageListWrapper>
      <StyledImageList
        cols={1.5}
        cellHeight={116}
        gap={spacing}
        component='div'
        $tileWidth={tileWidth}
        sx={{
          gridAutoFlow: "column",
          gridTemplateColumns: "repeat(auto-fill,minmax(400px,1fr)) !important",
          gridAutoColumns: "minmax(400px, 1fr)"
        }}
      >
        {children}
      </StyledImageList>
    </ImageListWrapper>
  );
}

export default ImageListSlider;
